/**
 * Ichigo & Co — KOC Affiliate Tracking
 * v1.0
 *
 * Luồng:
 * 1. Khách click link KOC: ichigoandco.com/?ref=maianh
 * 2. Script đọc ?ref= → lưu cookie koc_ref → redirect sang /discount/REF_MAIANH
 * 3. Shopify áp discount code vào session → redirect về trang gốc
 * 4. Script lưu cart attribute koc_ref (backup) → ghi vào order.note_attributes
 * 5. Webhook nhận order → tìm KOC theo discount_codes[] hoặc note_attributes
 */
(function () {
  'use strict';

  var cfg = window.IchigoAffiliate || {};
  var COOKIE_NAME   = cfg.cookieName    || 'koc_ref';
  var COOKIE_EXPIRY = cfg.cookieExpiry  || 30;
  var CART_URL      = cfg.cartUpdateUrl || '/cart/update.js';
  var CODE_PREFIX   = 'REF_';
  var REF_PARAM     = 'ref';

  // ── Cookie helpers ──────────────────────────────────────────

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value)
      + '; expires=' + expires
      + '; path=/'
      + '; SameSite=Lax'
      + (location.protocol === 'https:' ? '; Secure' : '');
  }

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  // ── URL helpers ─────────────────────────────────────────────

  function getRefParam() {
    var params = new URLSearchParams(window.location.search);
    var ref = params.get(REF_PARAM);
    if (!ref) return null;
    // Chuẩn hóa: uppercase, thêm prefix nếu chưa có
    ref = ref.toUpperCase().trim();
    if (!ref.startsWith(CODE_PREFIX)) ref = CODE_PREFIX + ref;
    return ref;
  }

  // ── Áp discount code qua Shopify redirect ──────────────────
  // Shopify native: /discount/CODE?redirect=PATH
  // Giúp code được gắn cứng vào session (không phụ thuộc cookie)

  function applyDiscountRedirect(code) {
    // Tránh redirect loop: kiểm tra sessionStorage flag
    if (sessionStorage.getItem('koc_applied') === code) return;

    var returnPath = window.location.pathname + window.location.search;
    // Xóa param ?ref= khỏi return URL để tránh trigger lại sau redirect
    var cleanParams = new URLSearchParams(window.location.search);
    cleanParams.delete(REF_PARAM);
    var cleanSearch = cleanParams.toString();
    returnPath = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '');

    sessionStorage.setItem('koc_applied', code);
    window.location.href = '/discount/' + code + '?redirect=' + encodeURIComponent(returnPath);
  }

  // ── Cập nhật cart attributes (backup attribution) ──────────
  // Ghi vào order.note_attributes để webhook dùng làm fallback

  function updateCartAttribute(code) {
    if (typeof fetch === 'undefined') return;
    fetch(CART_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { koc_ref: code } }),
    }).catch(function () {
      // Silent fail — không ảnh hưởng UX
    });
  }

  // ── Main ────────────────────────────────────────────────────

  function init() {
    var refCode = getRefParam();

    if (refCode) {
      // Khách vừa click link affiliate
      setCookie(COOKIE_NAME, refCode, COOKIE_EXPIRY);
      // Redirect để Shopify áp code vào session
      // (không redirect nếu đã có code giống trong session)
      var currentApplied = (cfg.appliedCode || '').toUpperCase();
      if (currentApplied !== refCode) {
        applyDiscountRedirect(refCode);
        return; // Dừng — page sẽ reload sau redirect
      }
    }

    // Đọc cookie hiện tại (khách đã visit trước đó)
    var storedCode = getCookie(COOKIE_NAME);
    if (storedCode) {
      // Cập nhật cart attribute mỗi khi tải trang (giữ attribution)
      updateCartAttribute(storedCode);
    }
  }

  // Chạy sau khi DOM sẵn sàng
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
